<section>
  <app-navbar></app-navbar>

  <div class="container-fluid">
    <div class="row mt-5">
      <div
        class="col-md-4 col-4 d-flex justify-content-center align-items-center flex-column"
      >
        <a routerLink="/train-bot">
          <div class="card">
            <div class="card-body">
              <img src="../../../assets/img/trainBot.png" alt="" />
            </div>
          </div>
        </a>
        <small class="mt-2">Train your bot</small>
      </div>
      <div
        class="col-md-4 col-4 d-flex justify-content-center align-items-center flex-column"
      >
        <a href="https://paytm.com/electricity-bill-payment" target="_blank">
          <div class="card">
            <div class="card-body">
              <img src="../../../assets/img/payBill.png" alt="" />
            </div>
          </div>
        </a>
        <small class="mt-2">Pay bills</small>
      </div>
      <div
        class="col-md-4 col-4 mt-3 d-flex justify-content-center align-items-center flex-column"
      >
        <a routerLink="/bot-info">
          <div class="card">
            <div class="card-body">
              <img src="../../../assets/img/myBot.png" alt="" />
            </div>
          </div>
        </a>
        <small class="mt-2">My Bot(s)</small>
      </div>
      <div
        class="col-md-4 col-4 mt-3 d-flex justify-content-center align-items-center flex-column"
      >
        <a routerLink="/diagnose">
          <div class="card">
            <div class="card-body">
              <img src="../../../assets/img/diagnosis.png" alt="" />
            </div>
          </div>
        </a>
        <small class="mt-2">Diagnosis</small>
      </div>
    </div>
  </div>
</section>
